module.exports = __webpack_public_path__ + "img/handricks-carnival.12885750.png";